import { List } from 'immutable';

import State from '../core/State';
import FacebookAdAccount from '../entity/FacebookAdAccount';
import FacebookIntegratedAdAccount from '../entity/FacebookIntegratedAdAccount';
import initialState from '../initialState';

export const setFacebookAdAccounts = (facebookAdAccounts: List<FacebookAdAccount>) => (state: State): State => ({
  ...state,
  facebookAdAccounts,
});

export const startIntegratedFacebookAdAccounts = () => (state: State): State => ({
  ...state,
  integratedFacebookAdAccounts: {
    ...state.integratedFacebookAdAccounts,
    fetching: state.integratedFacebookAdAccounts.fetching + 1,
  },
});

export const setIntegratedFacebookAdAccounts = (integratedFacebookAdAccounts: List<FacebookIntegratedAdAccount>) => (
  state: State,
): State => ({
  ...state,
  integratedFacebookAdAccounts: {
    adAccounts: integratedFacebookAdAccounts,
    fetching: state.integratedFacebookAdAccounts.fetching - 1,
  },
});

export const finishIntegratedFacebookCommunication = () => (state: State): State => ({
  ...state,
  integratedFacebookAdAccounts: {
    ...state.integratedFacebookAdAccounts,
    fetching: state.integratedFacebookAdAccounts.fetching - 1,
  },
});

export const disposeFacebookAdAccounts = () => (state: State): State => ({
  ...state,
  facebookAdAccounts: initialState.facebookAdAccounts,
});
